// server/smtp.js
Meteor.startup(function () {
  smtp = {
    username: 'bandbewerbung@kalkwerkfestival.org',
    password: 'tpC7x!tvfeyj',
    server:   'smtp.kalkwerkfestival.org',
    port: 25 
  }

  process.env.MAIL_URL = 'smtp://' + encodeURIComponent(smtp.username) + ':' + encodeURIComponent(smtp.password) + '@' + encodeURIComponent(smtp.server) + ':' + smtp.port;
});
